<template>
  <v-container>
      <v-row>
          <v-col>
              <h1 class="text-h2">Commandes</h1>
              <h2 id="global" class="text-h4">Principes de base</h2>
              <p>Les commandes représente les commandes clients, qu'elle soit lié à une préscription (Quotation) ou créer sur mesure ou encore dépendante d'une commande sur le site Xperience</p>
          </v-col>
      </v-row>
      <v-row>
          <v-col>
              <h3 id="list" class="text-h4">Liste des commandes et status</h3>
              <p>Dans la liste des commandes vous pouvez voir toutes les commandes existantes, regroupé par status</p>
              <p>Définition des status :</p>
                <ul>
                    <li>
                        <strong>NEW</strong> : la commande est créée mais n'a pas encore été validée, une Quotation créée depuis une préscription est dans ce status initial
                    </li>
                    <li>
                        <strong>OPEN</strong> : la commande a été validée, une facture a été créée et envoyée au client, a partir de ce status une commande ne peut plus être modifiée
                    </li>
                    <li>
                        <strong>CLOSE</strong> : la commande a été payée et envoyée au clients
                    </li>
                    <li>
                        <strong>CANCEL</strong> : la commande a été annulée
                    </li>
                </ul>
          </v-col>
      </v-row>
      <v-row>
          <v-col>
              <h3 id="create" class="text-h4">Création d'une commande sans préscription</h3>
              <p>Cliquer sur le bouton "CREATE ORDER" situé en haut à droite du la liste des commandes.</p>
              <p>Pour créer une commande il est important de saisir ces champs :</p>
                <ul>
                    <li>
                        <strong>SHOP</strong> : le shop au quel est rataché la préscription
                    </li>
                    <li>
                        <strong>CUSTOMER</strong> : le client
                    </li>
                    <li>
                        <strong>LOCATIONS</strong> : le lieu de préparation de la préscription
                    </li>
                    <li>
                        <strong>SHIPPING</strong> : le type d'envoi prévu
                    </li>
                    <li>
                        <strong>CURRENCY</strong> : la monnaie de la préscription
                    </li>
                    <li>
                        <strong>TAX RATE</strong> : le taux de la TVA appliqué
                    </li>
                    <li>
                        <strong>CLUB FITTER</strong> : le fitter qui a effectué la commande
                    </li>
                </ul>
                <p>Lorsque la commane est crée il est possible d'ajouter des produits et d'effectuer l'ensemble des actions lié au commandes.</p>
                <p>La première chose à faire est de saisir les adresses des facturation et de livraison de la commande dans l'onglet "CUSTOMER DETAILS"</p>
                <p>Vous trouverez l'ensemble des actions effectuées sur une commande dans l'onglet "HISTORY"</p>
                <p>Les commentaires saisi sur la commande se trouve dans "COMMENTS"</p>
                <p>Pour ajouter un ou plusieurs produits dans la commande, cliquer sur "ADD PRODUCTS",<br>vous pourrez rechercher un produit ou un set de produits à ajouter à la commande</p>
          </v-col>
      </v-row>
      <v-row>
          <v-col>
              <h3 id="discount" class="text-h4">Discounts</h3>
              <p>Il y a deux solutions pour effectuer un rabais sur une commandes:</p>
              <ul>
                  <li>Le rabais sur l'ensemble de la commande<br>
                  Accessible dans l'onglet "DISCOUNT", vous porez choisir un discount déjà utilisé pour en crée un nouveau depuis cette section</li>
                  <li>Le rabais sur un produit<br>
                  Accessible dans le menu de chaque produits (les trois petits points), vous pourez choisir un discount déjà utilisé pour en crée un nouveau depuis cette section</li>
              </ul>
          </v-col>
      </v-row>
      <v-row>
          <v-col>
              <h3 id="billing" class="text-h4">Facturation</h3>
              <p>Une commande reste en status "NEW" tant qu'elle n'a pas été validée, il est entendu qu'à partir du moment qu'une commande est validée le montant de la commande est dû par le client et une facture est créée.</p>
              <p>Il n'est plus possible de modifier une commande validée, il faut donc la réouvrir avec le bouton "RE-OPEN" qui va annuler la facture créée et remettre la commande sur le status "NEW"</p>
              <p>L'étape après la validation consiste à transmettre la facture au client, à partir de ce moment la facture sera ouverte et il sera possible d'envoyer la commande au stock (voir <router-link to="invoice#sent">Envoyer la facture au client</router-link></p>
          </v-col>
      </v-row>
      <v-row>
          <v-col>
              <h3 id="stock" class="text-h4">Envoi au stock pour montage</h3>
              <p>Afin de notifier l'équipe en charge des commandes et du montage, il faut cliquer sur le bouton "SEND TO STOCK" qui aura pour effet de rajouter cette commande à la liste des builds à effectué</p>
          </v-col>
      </v-row>
  </v-container>
</template>

<script>
export default { 

}
</script>

<style>

</style>